module.exports = __webpack_public_path__ + "img/32_12.f1d9b66b.png";